// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__l8vxq","sendOtp":"AuthorizeToLogin_sendOtp__3-_01"};